export const setDashboard_ = (dashboard) => {
	try {
		localStorage.setItem("dashboard", JSON.stringify(dashboard));
	} catch (err) {}
};
export const removeDashboard_ = () => {
	try {
		localStorage.removeItem("dashboard");
	} catch (err) {}
};
export const getDashboard_ = () => {
	try {
		const dashboard = JSON.parse(localStorage.getItem("dashboard"));

		if (dashboard === null) {
			return undefined;
		}
		return dashboard;
	} catch (err) {
		return null;
	}
};
